import { createLucideIcon } from 'lucide-react'

const UsersRoundCollaboration = createLucideIcon('users-round-collaboration', [
  ['circle', { cx: '8', cy: '8', r: '3' }],
  ['path', { d: 'M2.5 19.5v-.8A4.7 4.7 0 0 1 7.2 14h1.6a4.7 4.7 0 0 1 4.7 4.7v.8' }],
  ['circle', { cx: '17', cy: '9', r: '2.4' }],
  ['path', { d: 'M16.2 14.2a3.8 3.8 0 0 1 3.6 3.5v1.8' }]
])

export default UsersRoundCollaboration
